import { immerable } from "immer";
import { filtersTypeEnum, useAuthorization } from "@sttedra_ui/framework";

import { tableViews, useSmallAddLabel } from "@/composables/_commons/helper.js";
import { appUserList } from "@/api/users/users.api.js";

export default class UsersTableConfig {
  [immerable] = true;

  constructor(
    buildModal,
    enableRegister,
    deleteRegister,
    impersonate,
    updatePassword
  ) {
    const { modelRef: authorizationModelRef } = useAuthorization();

    const fields = [
      {
        field: "activo",
        label: "Activo",
      },
      {
        field: "nombre",
        label: "Nombre",
      },
      {
        field: "esInterno",
        label: "Origen",
      },
      {
        field: "afiliacion",
        label: "Unidad",
      },
      {
        field: "email",
        label: "Correo electrónico",
      },
      {
        field: "rol",
        label: "Rol",
      },
      {
        field: "numInformes",
        label: "Nº Informes",
        sortable: false,
      },
      {
        field: "grupos",
        label: "Grupos del usuario",
        sortable: false,
      },
      {
        field: "ultimoAcceso",
        label: "Última conexión",
      },
    ];

    const advancedFilters = [
      {
        field: "nombre",
        label: "Nombre",
      },
      {
        field: "afiliacion",
        label: "Unidad",
      },
      {
        field: "email",
        label: "Correo electrónico",
      },
      {
        field: "rol",
        label: "Rol",
      },
    ];

    return {
      title: "Usuarios",
      api: appUserList,
      schema: fields,
      actions: {
        header: [
          {
            label: useSmallAddLabel()
              ? "Añadir CM"
              : "Añadir cuenta del ministerio",
            icon: "add",
            command: () => buildModal(null, "ministerio"),
            extended: true,
          },
          {
            label: useSmallAddLabel()
              ? "Añadir CI"
              : "Añadir cuenta individual",
            icon: "add",
            command: () => buildModal(null, "individual"),
            extended: true,
          },
        ],
        item: [
          {
            label: "Editar",
            icon: "edit",
            command: (event) => buildModal(event, "individual"),
            extended: false,
            disabled: (data) => data.esInterno,
          },
          {
            label: "Cambiar contraseña",
            icon: "key",
            command: (event) => updatePassword(event),
            extended: false,
            disabled: (data) => data.esInterno,
          },
          {
            label: "Impersonar",
            icon: "supervised_user_circle",
            command: (event) => impersonate(event),
            extended: false,
            disabled: (data) =>
              data.email == authorizationModelRef.value.email || !data.activo,
          },
          {
            label: "Alternar visibilidad",
            icon: "block",
            command: (event) => enableRegister(event),
            extended: false,
            classObj: ["delete-action"],
            disabled: (data) => data.email == authorizationModelRef.value.email,
          },
          {
            label: "Borrar",
            icon: "delete",
            command: (event) => deleteRegister(event),
            extended: false,
            classObj: ["delete-action"],
            disabled: (data) => data.email == authorizationModelRef.value.email,
          },
        ],
      },
      filters: [
        {
          type: filtersTypeEnum.GLOBAL,
          fields: advancedFilters,
        },
        {
          type: filtersTypeEnum.ADVANCED,
          fields: advancedFilters,
        },
      ],
      views: tableViews(),
    };
  }
}
